<template>
    <section class="content">
        <div class="container-fluid">
            <div class="row">
                <p>P2 Close Rate</p>
            </div>

             <div class="row">

                <div class="col-md-12 col-xl-4">
                    <div class="info-box bg-c-yellow card">
                        <div class="info-box-content">
                            <h6>Last PP</h6>
                            <div class="row">   
                                <div class="col-3 b-r-default">
                                    <p class="m-b-5">Work Days</p>
                                    <h5 class="text-c-red">{{ dbPeriods[1].PeriodWorkingDays }}</h5>
                                </div>
                                <div class="col-3 b-r-default">
                                    <p class="m-b-5">KPI Reached</p>
                                    <h5 class="text-c-red">{{ dbPeriods[1].KPI_reached }}</h5>
                                </div>
                                <div class="col-3 b-r-default">
                                    <p class="m-b-5">KPI Not Reached</p>
                                    <h5 class="text-c-red">{{ dbPeriods[1].KPI_not_reached }}</h5>
                                </div>  
                            </div>                                                          
                            <i class="card-icon feather icon-filter"></i>
                        </div>
                    </div>
                </div>

                <div class="col-md-6 col-xl-4">
                    <div class="info-box bg-c-blue order-card">
                        <div class="info-box-content">
                            <h6>Current Pay Period</h6>
                            <div class="row">   
                                <div class="col-3 b-r-default">
                                    <p class="m-b-5">Work Days</p>
                                    <h5 class="text-c-red">{{ dbPeriods[0].PeriodWorkingDays }}</h5>
                                </div>
                                <div class="col-3 b-r-default">
                                    <p class="m-b-5">KPI Reached</p>
                                    <h5 class="text-c-red">{{ dbPeriods[0].KPI_reached }}</h5>
                                </div>
                                <div class="col-3 b-r-default">
                                    <p class="m-b-5">KPI Not Reached</p>
                                    <h5 class="text-c-red">{{ dbPeriods[0].KPI_not_reached }}</h5>
                                </div>  
                            </div>                                                          
                            <i class="card-icon feather icon-users"></i>
                        </div>
                    </div>
                </div>

                <div class="col-md-6 col-xl-4">
                    <div class="info-box bg-c-green order-card">
                        <div class="info-box-content">
                            <h6>Minimal Requirements (per day)</h6>
                            <div class="row">

                               <div class="col-6 b-r-default">
                                    <p class="m-b-5">Cases Sold</p>
                                    <h5 class="text-c-red">0.9</h5>
                                </div>
                                <div class="col-6 b-r-default">
                                    <p class="m-b-5">Close Rate</p>
                                    <h5 class="text-c-red">10%</h5>
                                </div>

                            </div>                                                        
                            <i class="card-icon feather icon-radio"></i>
                        </div>
                    </div>
                </div>  
            </div>


            <div class="row">
                        
                <div class="col-sm-6">  
                    <div class="card">
                        <div class="card-header">
                            <div class="row">                                                   
                                <div class="col">
                                    <h5>Last Pay Period</h5>
                                </div>
                            </div>
                        </div>
                        <div class="card-body p-0">
                            <div class="table-responsive">
                                <table class="table table-striped table-bordered" id="last_period_table">
                                    <thead>
                                        <tr>
                                            <th v-for="(item, index) in TableHeaders">{{ item }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in StatsData.last_period">
                                            <td>{{ item.user_name }}</td>
                                            <td class="text-center">{{ item.not_reached }}</td>
                                            <td class="text-center" v-for="(item2, index2) in item.data">
                                            {{ item2 }}

                                                <div v-if="item.expected_min[index2] != '0'" class='progress' data-toggle='tooltip' :title="'Required: ' + item.expected_min[index2]">
                                                    <div class='progress-bar progress-bar-danger tooltip-item' role='progressbar'  :style="'height: 15px; width: '+item.results_percentage[index2]+'%'" :aria-valuenow='item.results_percentage[index2]' aria-valuemin='0' aria-valuemax='100'></div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-sm-6">  
                    <div class="card">
                        <div class="card-header">
                            <div class="row">                                                   
                                <div class="col">
                                    <h5>Current Pay Period</h5>
                                </div>
                            </div>
                        </div>
                        <div class="card-body p-0">
                            <div class="table-responsive">
                                <table class="table table-striped table-bordered" id="current_period_table">
                                    <thead>
                                        <tr>
                                            <th v-for="(item, index) in TableHeaders">{{ item }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in StatsData.current_period">
                                            <td>{{ item.user_name }}</td>
                                            <td>{{ item.not_reached }}</td>
                                            <td v-for="(item2, index2) in item.data">
                                            {{ item2 }}

                                                <div v-if="item.expected_min[index2] != '0'" class='progress' data-toggle='tooltip' :title="'Required: ' + item.expected_min[index2]">
                                                    <div class='progress-bar progress-bar-danger tooltip-item' role='progressbar'  :style="'height: 15px; width: '+item.results_percentage[index2]+'%'" :aria-valuenow='item.results_percentage[index2]' aria-valuemin='0' aria-valuemax='100'></div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </section>
</template>

<script>

    export default {
        data () {

            return {
                TableHeaders: {},
                StatsData: {},
                dbPeriods: {},
            }

        },
        mounted() {


        },
        updated: function () {

          this.$nextTick(function () {
                $('#last_period_table').DataTable();
                $('#current_period_table').DataTable();
          })

        },
        methods: {

            getStatsData() {
                axios.get("/api/v1/stats/7").then(({ data }) => {
                    this.TableHeaders = data.data.TableHeaders;
                    this.StatsData = data.data.StatsData
                    this.dbPeriods = data.data.dbPeriods
                });
            }


        },
        created() {

            this.getStatsData();
        }
    }
</script>
